import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Product  {
    _originalTypeClassName = "zPMO.BO.Product";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Product.translate = translateService;
}
this.Subproducts = [];
this.Id = null;
this.Name = null;
this.IsSubscription = false;
this.IsSupportContract = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
IsSubscription:any;
IsSupportContract:any;
Subproducts:any;
static setSubproducts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Subproducts == null) $this.Subproducts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Subproducts.length > 0) {
                    Domain.Product.removeSubproducts($this, $this.Subproducts[0]);
                }

                Domain.Product.addManySubproducts($this, copyItems);
            }
static addManySubproducts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Product.addSubproducts($this, items[i]);
                }
            }
static addSubproducts = ($this, item) => {
                if ($this.Subproducts == null) $this.Subproducts = [];
                if (item == null || $this.Subproducts.indexOf(item) > -1) return;
                $this.Subproducts.push(item);
Domain.Subproduct.addProducts(item, $this);
}
static addRangeSubproducts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Product.addSubproducts($this, item));
            }
static removeSubproducts = ($this, item) => {
                if ($this == null || $this.Subproducts == null || $this.Subproducts.indexOf(item) === -1) return;
                var _index = $this.Subproducts.indexOf(item);
                $this.Subproducts.splice(_index, 1);
Domain.Subproduct.removeProducts(item, $this);
}
static clearSubproducts = ($this) => { $this.Subproducts = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}